export default __webpack_public_path__ + "static/media/menu4.749836ad.webp";